import React, { useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Defs from "../../components/RoyalMahal/art/Defs";
import { ScrollerContext } from "../../components/RoyalMahal/hooks";
import GateScreen from "../../components/RoyalMahal/scenes/GateScreen";
import Hero from "../../components/RoyalMahal/scenes/Hero";
import CalendarSection from "../../components/RoyalMahal/scenes/CalendarSection";
import Couple from "../../components/RoyalMahal/scenes/Couple";
import CouplePortrait from "../../components/RoyalMahal/scenes/CouplePortrait";
import LetterEnvelope from "../../components/LetterEnvelope/LetterEnvelope";
import { ConfettiTypes } from "../../hooks/useConfetti";
import Events from "../../components/RoyalMahal/scenes/Events";
import VenueSection from "../../components/VenueSection/VenueSection";
import Rsvp from "../../components/RoyalMahal/scenes/Rsvp";
import Blessings from "../../components/RoyalMahal/scenes/Blessings";
import Closing from "../../components/RoyalMahal/scenes/Closing";
import "../../components/RoyalMahal/styles/royalMahal.scss";

const FONTS =
  "https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500&family=Parisienne&display=swap";

/**
 * Royal Mahal: a Rajput-palace invitation. It opens at the palace gate; once
 * the doors open, the card and the rest of the invitation unfold as the guest
 * scrolls. Same information as the other themes; see components/RoyalMahal.
 */
const RoyalMahal = ({ isInviteOpen, onOpenInvite }) => {
  const scrollerRef = useRef(null);
  const [revealed, setRevealed] = useState(isInviteOpen);
  const [gateGone, setGateGone] = useState(isInviteOpen);

  const reveal = () => {
    scrollerRef.current?.scrollTo(0, 0);
    setRevealed(true);
    onOpenInvite?.();
  };

  return (
    <ScrollerContext.Provider value={scrollerRef}>
      <Helmet>
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link rel="stylesheet" href={FONTS} />
      </Helmet>
      <div ref={scrollerRef} className={`royal-mahal ${revealed ? "is-revealed" : "is-gated"}`}>
        <Defs />
        {!gateGone && <GateScreen onReveal={reveal} onDone={() => setGateGone(true)} />}
        <Hero />
        <Couple />
        <CouplePortrait />
        <CalendarSection />
        <Events />
        <LetterEnvelope confettiType={ConfettiTypes.rosePetals} />
        <VenueSection variant="plain" />
        <Rsvp />
        <Blessings />
        <Closing />
        <Footer footerClass={"rm-footer"} />
        <Scrollbar />
      </div>
    </ScrollerContext.Provider>
  );
};

const mapStateToProps = (state) => ({
  isInviteOpen: state.inviteDetails?.isOpen || false,
});

export default connect(mapStateToProps)(RoyalMahal);
